<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-12 ccs-layout--no-pad">
      <ccs-input class="ccs-6" v-model="fieldsValues.user_id" v-bind="fieldsDefinitions.user_id"
        :items="usersForSelect"
        @change="onUserSearch" @error="(err) => setFieldError('user_id', err)"/>
      <ccs-input class="ccs-6" v-model="fieldsValues.role" v-bind="fieldsDefinitions.role"
        :items="rolesList" :modifiers="['no_cancel']"
        @error="(err) => setFieldError('role', err)"/>
      <ccs-input class="ccs-6" v-model="fieldsValues.fnd_organization_id"
        v-bind="fieldsDefinitions.fnd_organization_id"
        :items="organizationsForSelect" @change="onOrganizationSearch"
        @error="(err) => setFieldError('fnd_organization_id', err)"/>
      <ccs-input class="ccs-6" v-model="fieldsValues.fnd_id" v-bind="fieldsDefinitions.fnd_id"
        :items="fndsForSelect" @change="onFndSearch"
        @error="(err) => setFieldError('fnd_id', err)"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="addUserToFnd">
          Привязать
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import FormHelper from '@/mixins/FormHelper.js';
import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'FndEmployees',
  mixins: [AutocompleteParent, FormHelper],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      fieldsDefinitions: {
        user_id: {
          isValid: false,
          error: '',
          required: true,
          type: "autocomplete",
          label: "Пользователь",
          placeholder: "Введите 3 символа для поиска",
        },
        fnd_organization_id: {
          isValid: false,
          error: '',
          required: true,
          type: "autocomplete",
          label: "Организация",
          placeholder: "Поиск по названию",
        },
        role: {
          isValid: false,
          error: '',
          required: true,
          type: "dropdown",
          label: "Роль",
          placeholder: "Выберите роль",
        },
        fnd_id: {
          isValid: true,
          error: '',
          required: true,
          type: "autocomplete",
          label: "ФНД",
          placeholder: "Поиск по названию",
        },
      },
      fieldsValues: {
        role: undefined,
        user_id: undefined,
        fnd_id: undefined,
        fnd_organization_id: undefined,
      },
      fndsForSelect: [],
      usersForSelect: [],
      organizationsForSelect: [],
      rolesList: [{
        prop: 'block_leader',
        text: 'Лидер блока',
      }, {
        prop: 'leader',
        text: 'Лидер ФНД'
      }, {
        prop: 'employee',
        text: 'Сотрудник ФНД',
      }],
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return undefined;
      },
    },
  },
  computed: {
    ...mapState('events', ['event']),
    filteredEmployees() {
      if(!this.$props.data || !this.$props.data.id) return [];
      return this.$props.data.filter(item => item.full_name.indexOf(this.employeeSearch) !== -1)
    }
  },
  methods: {
    ...mapActions('events', ['getFndEmployees']),
    ...mapActions('fnd', ['createFnd', 'updateFnd', 'attachUserToFnd', 'detachUserFromFnd']),
    async onFndSearch(text) {
      [this.fndsForSelect] = await this.getAutocompleteData('/v1/fnd/list', text, 'id', 'code', (item) => item.code);
    },
    async onOrganizationSearch(text) {
      [this.organizationsForSelect] = await this.getAutocompleteData(`/v1/fnd/organizations/list`, text, 'id', 'name');
    },
    async onUserSearch(text) {
      [this.usersForSelect, this.usersForSelectRaw]  = await this.getAutocompleteData('/v1/users/list',
        text, 'id', 'email', (item) => `${item.full_name} <${item.email}>`);
    },
    async addUserToFnd() {
      this.validateForm();
      if (this.isFormValid) {
        try {
          await this.attachUserToFnd({
            ...this.fieldsValues,
            event_id: this.event.id,
          });
          if (this.$props.data === this.fieldsValues.fnd_id) this.getFndEmployees(this.fieldsValues.fnd_id);
          this.$toasted.success('Пользователь прикреплен');
          this.$emit('close');
        } catch (err) {
          this.showServerValidationErrors(err);
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fnd_employee {

  &-action {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    .action-button {
      margin-left: 20px;
    }

  }

  &-table {
    max-height: 41*6px;
  }

}
</style>